export default "__VITE_ASSET__36i9qY1p__"